export const SMS_CONSENT_DISCLOSURE_VERSION = "2026-07-30";
export const SMS_CONSENT_SOURCE = "patient_portal_security";

export const SMS_CONSENT_DISCLOSURE =
  "By enabling text messages, you agree to receive transactional SMS from Brightlight Health about appointments, billing, and account activity. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. Consent is not required to receive care.";
